module.exports = __webpack_public_path__ + "media/images/hero-allcare-banner-1920-d4f55cca497bc4f3aec612ea9eebfc2b.webp";